import Stats from 'frontend_stats';
import FullstoryUtil from 'fullstory_util';
import PersonalizeUtil from 'personalize_util';
import {
	getListingData,
	parseQuery,
	BrazeUtil,
	TrackUtil,
	HeapUtil,
	getCustomData,
	plural,
} from 'core/utils';
import { getListingProps, updateUserAttributes } from 'core/utils/Braze';

function setupOptimizeCallback() {
	if (!window?.gtag) {
		return;
	}

	window.gtag('event', 'optimize.callback', {
		callback: (combination, experimentId, containerId) => {
			// Nice-to-have debugging & tracking for Optimize AB experiences
			console.debug(`optimize.callback for http://optimize.google.com/experiences/${experimentId}?containerId=${containerId}&combination=${combination}`);

			Stats.trackGeneric('a/b test init', {
				cus1: 'experiment:' + experimentId,
				cus2: 'cell:' + combination,
			});

			// Tag user in Heap:
			HeapUtil.track("Experiment Impression", {
				experiment: experimentId,
				variant: combination,
			});
		}
	});
}

export default {
	base() {
		// Tracking
		BrazeUtil.initialize();
		Stats.registerGaParams();
		// Expose TrackUtil for backbone to consume
		window.TrackUtil = TrackUtil;
		Stats.trackImpression('marketplace');
		/* Shared Across Templates */
		Stats.trackLinks(".listing-box a");
		Stats.trackLinks(".exit-url");

		setupOptimizeCallback();

		Stats.trackPageload();
		FullstoryUtil.sendUrlToSentry();
		HeapUtil.identify();
	},

	trackQueryParams() {
		// Tracking query
		const qParams = parseQuery(window.location.search);
		if (qParams.pt || qParams.gs || qParams.cn || qParams.pn || qParams.sn) {
			/*
			 * `discovery`: event used to track buyers 'discovering' content (listings, collections, categories).
			 * 		Used to get better insights on the effectiveness of merchandicing.
			 * cus2: <pt> page_type:    assuming discovery url structure:
			 * cus3: <gs> general_slug: `/<page_type>/<general_slug>`
			 * cus4: <pn> page_number:  page within result set
			 * cus5: <cn> card_number:  position within discovery page
			 * cus6: <ft> filter_tags:  filter-group-tags applied to result set
			 * cus7: <sn> section_name: section name card is displayed within
			 */
			Stats.trackGeneric('discovery', {
				cus1: 'track',
				cus2: qParams.pt,
				cus3: qParams.gs,
				cus4: qParams.pn,
				cus5: qParams.cn,
				cus6: qParams.ft,
				cus7: qParams.sn,
			});
		}
	},

	listing() {
		const listing = getListingData();
		if (listing) {
			TrackUtil.trackEvent("product_view", {
				braze: [getListingProps(listing)],
			});

			// Handle personalize events & possible recommendation stats:
			PersonalizeUtil.onListingView(listing.listingId, listing.categories);

			updateUserAttributes({ boxesViewed: [listing.name] });
		}

		// Track the "in-house utm" params
		this.trackQueryParams();
	},

	checkout() {
		BrazeUtil.initialize();
		// Expose TrackUtil for backbone to consume
		window.TrackUtil = TrackUtil;
		window.BrazeUtil = BrazeUtil;
		// Checkout doesn't do `Analytics.base()`
		setupOptimizeCallback();
	},

	discovery() {
		this.trackQueryParams();
		if (! window) return;
		const pageType = window?.cj?.page_type;
		const trackable = pageType === "category" || pageType === "subcategory";
		if (! trackable) return;
		const headerProps = getCustomData(window.cj.header_props, {});
		const slug = headerProps.bottomNavProps.currentSlug;
		const attributes = {};
		const key = `${plural(pageType)}Viewed`;
		attributes[key] = [slug];
		updateUserAttributes(attributes);
	}
};
